import React from 'react';
import styles from './consultancyStep.module.css';

interface StepActionsProps {
  children: React.ReactNode;
  className?: string;
}

const StepActions: React.FC<StepActionsProps> = ({ children, className = '' }) => (
  <div className={`${styles.stepActions} ${className}`.trim()}>{children}</div>
);

export default StepActions;
